import { Component, OnInit } from '@angular/core';
import { ModalService, ModalType } from '../../modal/services/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DError, DLogger, DContextoMuisca, DContextoMuiscaServicio } from '@dian/core';
import { DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { DAniosFormato, DPeriodicidad, DPeriodicidadFormato, DPeriodoFormato, DPeriodo } from '@dian/api-formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { GeneralService } from '../../services/general.service';
import { MatDialog } from '@angular/material';
import { ModoDiligenciemientoComponent } from '../shared/modals/modo-diligenciemiento/modo-diligenciemiento.component';
import { Buffer } from 'buffer';

@Component({
  selector: 'app-crear-formulario',
  templateUrl: './crear-formulario.component.html',
  styleUrls: ['./crear-formulario.component.css']
})
export class CrearFormularioComponent implements OnInit {

  form: FormGroup;
  anios: (number | string)[] = [];
  submitted = false;
  aniosFormato: DAniosFormato;
  mostrarOtros: boolean = false;
  anioSeleccionado:number;
  periodicidadFormato: DPeriodicidadFormato;
  periodicidadSelecionada: string;
  periodosFormato: DPeriodoFormato;
  periodoSeleccionado;
  periodicidades: DPeriodicidad[] = [];
  periodos: DPeriodo[] = [];
  datosUsuario: DContextoMuisca;
  domain = '';
  private tiempo:Date;
  anioSugerida: number;

  private estadosCarga = {
    anios: false
  };

  constructor(private modalService: ModalService,
    private  router: Router,
    private fb: FormBuilder,
    private logger: DLogger,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private configuracionFormulario: DFormularioConfiguracion,
    private generalService: GeneralService,
    private dialog: MatDialog,
    private route: ActivatedRoute,) { 
      this.buildForm();
      this.generalService.datosRespuesta$.subscribe(res =>{
        this.datosUsuario = res;
      })
      this.tiempo = new Date();               
      let tiempoReal = new Date();                    
      setInterval(()=>{
          tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
          this.tiempo = new Date(tiempoReal);                    
      }, 1000);
    }

  ngOnInit() {
    this.domain = window.location.origin;
    //this.showWelcome();
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
    this.route.queryParams.subscribe(params => {
      const paramValue = params['idRequest'];
      if(paramValue){
        const decodedBuffer = Buffer.from(paramValue, 'base64');
        const decodedString = decodedBuffer.toString('utf-8');
        this.anioSugerida = parseInt(decodedString.split('=')[1]);
      }
    });
  }

  buildForm(){
    this.form = this.fb.group({
      anio: new FormControl('', Validators.required),
      periodicidad: new FormControl('', Validators.required),
      periodo: new FormControl('', Validators.required)
    });
    this.form.controls.periodicidad.disable();
    this.form.controls.periodo.disable();
    this.obtenerAnios();
  }

  showWelcome(){
    let message = '<div class="text-left">';
    message += '<div class="mb-2">'
    message += '<p class="text-small mb-2">Siga los pasos en orden para completar su declaración de renta:</p>'
    message += '<p class="mb-1"><span class="item-list">1</span><b>Seleccione el año a declarar.</b></p>'
    message += '<p class="text-small mt-0 pl-3">Recuerde que es año anterior, por ejemplo, en 2024, se declara el año 2023.</p>'
    message += '</div>'
    message += '<div class="mb-2">'
    message += '<p class="mb-1"><span class="item-list">2</span><b>Diligencie el formulario.</b></p>'
    message += '<p class="text-small mt-0 pl-3">Diligencie la información que se ajuste a su realidad jurídica, económica y financiera.</p>'
    message += '</div>'
    message += '<div class="mb-2">'
    message += '<p class="mb-1"><span class="item-list">3</span><b>Firme el formulario.</b></p>'
    message += `<p class="text-small mt-0 pl-3">Utilice la firma electrónica. Si no la tiene, puede generarla <a class="router-link" href="${this.domain}/WebDashboard/DefDashboard.faces">aquí</a>. También puede imprimir dos copias y firmarlas con tinta negra.</p>`
    message += '</div>'
    message += '<div class="mb-2">'
    message += '<p class="mb-1"><span class="item-list">4</span><b>Presente el formulario.</b></p>'
    message += '<p class="text-small mt-0 pl-3">En línea o de manera presencial en un banco.</p>'
    message += '</div>'
    message += '<div class="mb-2">'
    message += '<p class="mb-1"><span class="item-list">5</span><b>Si hay un saldo a pagar, realice el pago.</b></p>'
    message += '<p class="text-small mt-0 pl-3">Puede hacerlo en línea o presencial.</p>'
    message += '</div>'
    message += '</div>'

    let infoMessage = '<p class="mb-1"><b>Tenga en cuenta</b></p>';
    infoMessage += '<ul class="pl-2"><li>Tener el RUT actualizado. <a class="router-link" href="https://www.dian.gov.co/atencionciudadano/Agendamiento-de-Citas/Paginas/Inicio.aspx" target="_blank">Aquí</a> lo puede hacer.</li>';
    infoMessage += `<li>Obtenga su firma electrónica <a class="router-link" href="${this.domain}/WebDashboard/DefDashboard.faces">aquí</a> para ahorrar tiempo.</li>`;
    infoMessage += '<li>Reuna toda la información relacionada con su patrimonio, ingresos, pagos realizados, etc. <a class="router-link" href="https://micrositios.dian.gov.co/renta-personas-naturales-ag-2022/" target="_blank">Más información</a></li>';
    infoMessage += '<li>Puede resolver sus preguntas sobre la declaración de renta con nuestro asistente virtual o visite el micrositio informativo <a class="router-link" href="https://micrositios.dian.gov.co/renta-personas-naturales-ag-2023/" target="_blank">Aquí</a>.</li>';
    infoMessage += '<li>Requiere total atención y disposición.</li>';
    infoMessage += '</ul>';
    const configBody = {
      title: 'Le damos la bienvenida',
      message: message,
      main_button: "Iniciar",
      secondary_button: "Salir",
      info_message_top: infoMessage, 
      main_action: "accept",
      text_align: "text-center",
      width: '650px',
      button_align: 'text-left',
      current_icon: './assets/img/png_v2/crear.png',
      onSecondaryAction: ()=>{this.router.navigate(['/', 'ingreso'])}
     }
     this.modalService.show(ModalType.SUCESS, configBody)
  }
  get formControls(){
    return this.form.controls;
  }

  /**
    * @desc Funcion para obtener los aÃ±os
    */
  private obtenerAnios() {
    let observableServicio = this.dServicioRESTAPI.consultarAniosFormato();
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Años ", res);
            this.aniosFormato = <DAniosFormato>res;               
            let anios:Array<number>=[];
            this.aniosFormato.anios.forEach((anio) =>{
                if(Number(anio)>2016){
                    anios.push(anio);
                } else {
                  this.anios.push('Otros años');
                  this.mostrarOtros = true;
                }
            });
            this.anios=anios;
            if(this.mostrarOtros) this.anios.push("Otros años");
            if (this.anioSugerida) {
              this.form.controls['anio'].setValue(this.anioSugerida);
              this.anioSeleccionado = this.anioSugerida;
              this.obtenerPeriodicidad(this.anioSeleccionado);
              this.validarAnularDefinitivos('inicial');
            }else if (this.aniosFormato.anios.length === 1) {
                this.form.controls['anio'].setValue(this.aniosFormato.anios[0]);
                this.anioSeleccionado = this.aniosFormato.anios[0];
                this.obtenerPeriodicidad(this.anioSeleccionado);
            }                
            this.estadosCarga.anios = true;             
        },
        error => {
            this.estadosCarga.anios = true;
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de aÃ±os.");
        }
    );
  }

  onChangeAnio(event){
    if(event.target.value !== 'Otros años') {
      this.anioSeleccionado = event.target.value;
      this.obtenerPeriodicidad(event.target.value);
    }else {
      this.redireccionarSelectorFlex();
    }
    
  }

  public redireccionarSelectorFlex() {
    window.location.href = `${window.location.origin}/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=${this.configuracionFormulario.NUMERO_FORMULARIO}`;
}

   /**
    * @desc Funcion para obtener la periodicidad
    */
   private obtenerPeriodicidad(anio:number) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.consultarListaPeriodicidad(anio);
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Periodicidad ", res);
            this.periodicidadFormato = <DPeriodicidadFormato>res;
            this.periodicidades = this.periodicidadFormato.listaPeriodicidades;
            if (this.periodicidadFormato.listaPeriodicidades.length === 1) {
                this.form.controls['periodicidad'].setValue(this.periodicidadFormato.listaPeriodicidades[0].nombre)
                this.periodicidadSelecionada = this.periodicidadFormato.listaPeriodicidades[0].nombre;
                this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
            }else {
              this.form.controls['periodicidad'].enable();
              this.form.controls['periodicidad'].updateValueAndValidity();
            }
            precarga.close();
        },
        error => {
            precarga.close();
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodicidades.");
        }
    );
  }

  onChangePeriodicidad(event){
    this.periodicidadSelecionada = event.target.value;
    this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
  }

   /**
    * @desc Funcion para obtener los periodos
    */
   private obtenerPeriodos(anio:number, periodicidad:string) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.consultarListaPeriodos(anio, periodicidad);
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Periodos ", res);
            this.periodosFormato = <DPeriodoFormato>res;
            this.periodos = this.periodosFormato.listaPeriodos;
            if (this.periodosFormato.listaPeriodos.length === 1) {
                this.form.controls['periodo'].setValue(this.periodosFormato.listaPeriodos[0].nombre);
                this.periodoSeleccionado = this.periodosFormato.listaPeriodos[0];
            }else {
              this.form.controls['periodo'].enable();
              this.form.controls['periodo'].updateValueAndValidity();
            }
            precarga.close();
        },
        error => {
            precarga.close();
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodos."); 
        }
    );
  }
  
  validarAnularDefinitivos(data: string){
    if (`${this.anioSeleccionado}` === '2022'
      || `${this.anioSeleccionado}` === '2023')
      //|| `${this.anioSeleccionado}` === '2024') 
      {
  /////////////////Habilitar no experto
     
      let config = {
        disableClose: true,
        maxWidth: '400px',
        data: {}
      };
      let dialogRef = this.dialog.open(ModoDiligenciemientoComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.generalService.enviarCrearBorrador({anioSeleccionado: this.anioSeleccionado, 
            dataAdicional:  data, 
            periodoSeleccionado: this.periodoSeleccionado, 
            periodicidadSelecionada: this.periodicidadSelecionada,
            modoNoExperto:  result === 'noExperto' ? true : false})
        }
      });
    }else {
      this.generalService.enviarCrearBorrador({anioSeleccionado: this.anioSeleccionado, 
        dataAdicional:  data, 
        periodoSeleccionado: this.periodoSeleccionado, 
        periodicidadSelecionada: this.periodicidadSelecionada})
    }
  }
  



    
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/crear-formulario/crear-formulario.component.ts